import $ from 'jquery';

function initializeTwitterKeyboardNavigationDisable(){
  window.addEventListener("message",blockNavigation)
}

/**
 * Block keyboard navigation inside the twitter embeded iframe
 * by listening for the event thrown and checking if it's fired
 * from twitter widget
 */
function blockNavigation(event) {
  //Check if the event thrown is when twitter embed is initialized
  if (event.data?.["twttr.embed"]?.method === "twttr.private.initialized") {
    //Add tabindex of -1 to block keyboard navigation
    $("#twitter-widget-0").attr("tabindex", "-1")
    //After tabindex attribute is added, we can remove the event listener
    window.removeEventListener("message",blockNavigation)
  }
}

export default initializeTwitterKeyboardNavigationDisable
